import { render, staticRenderFns } from "./ReferenceTypeDropdown.vue?vue&type=template&id=3d8400f2&"
import script from "./ReferenceTypeDropdown.vue?vue&type=script&lang=ts&"
export * from "./ReferenceTypeDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceTypeDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports